/**
 * Registro de adopción del contrato de anchos de columnas.
 *
 * Ver `docs/ANCHO_COLUMNAS_TABLAS.md`.
 *
 * El contrato es global en su definición pero de adopción explícita: una tabla
 * sólo lo usa si su `TableId` está en `TABLES_WITH_WIDTH_CONTRACT`. Todo lo que
 * no esté en ese set conserva exactamente el comportamiento anterior.
 */

/** Identificador estable de cada tabla que puede adoptar el contrato de anchos. */
export enum TableId {
  InvoiceList = "invoice-list",
  InvoiceListConsolidated = "invoice-list-consolidated",
  InvoiceHistory = "invoice-history",
  Inbox = "inbox",
  ReportInvoice = "report-invoice",
  ClientList = "client-list"
}

/**
 * Tablas migradas al contrato de anchos.
 *
 * Agregar un `TableId` a este set es la ÚNICA acción necesaria para migrar una
 * tabla; sacarlo es el rollback completo (ver CV-15 en la documentación).
 */
export const TABLES_WITH_WIDTH_CONTRACT: ReadonlySet<TableId> =
  new Set<TableId>([
    TableId.InvoiceList // GDC-5159
  ]);

export const usesWidthContract = (tableId?: TableId): boolean =>
  tableId !== undefined && TABLES_WITH_WIDTH_CONTRACT.has(tableId);

/**
 * Clase que habilita las reglas CSS del contrato. Sin ella, las utilitarias
 * `col-*` no tienen ningún efecto.
 */
export const WIDTH_CONTRACT_CLASS = "table-width-contract";
